import React, { useState } from 'react';
import { CardNumberElement,CardExpiryElement,CardCvcElement, useStripe, useElements } from '@stripe/react-stripe-js';
import {  Form, Button } from "react-bootstrap";
import loader from '../../assests/loader.gif';
import { gettoastwarning } from '../../Utils/Common';
import API from '../../Utils/Api';
import { useNavigate } from "react-router-dom";

const CheckoutForm = ({ inputs,inputsche,qty }) => {
	const [loading,setLoading] = useState(false);
	const navigate = useNavigate();
	const stripe = useStripe();
  const elements = useElements();

const handleSubmit = async (e) => {
    e.preventDefault();

    if (!stripe || !elements) return;
 
    setLoading(true);

    try {
    		var is_ireland=0;
    		if(parseInt(inputsche.country_id)===105)
    			{
    				is_ireland=0;
    			}else if(parseInt(inputsche.country_id)===232)
    			{
    				is_ireland=2;
    			}else{
    				is_ireland=1;
    			}

    		// Create payment intent
        let formData = new FormData();
        formData.append('email', inputsche.email);
        formData.append('first_name', inputsche.first_name);
        formData.append('last_name', inputsche.last_name);
        formData.append('country_code', inputsche.country_code);
        formData.append('mobile_number', inputsche.mobile_number);
        formData.append('country_id', inputsche.country_id);
        formData.append('county', inputsche.county);
        formData.append('address', inputsche.address);
        formData.append('postcode', inputsche.postcode);
        formData.append('product_amount', inputs.price);
        formData.append('product_vat', inputs.vat_total);
        formData.append('product_vat_per', inputs.vat);
        formData.append('is_ireland', is_ireland);
        formData.append('shipping_within_ireland', inputs.shipping_within_ireland);
        formData.append('international_shipping', inputs.international_shipping);
        formData.append('grand_total', inputs.grand_total);
        formData.append('product_id', inputs.id); 
        formData.append('qty', qty);
        formData.append('is_newsletter', inputsche.single_event ? 1 : 0);
        if(inputsche.single_event)
		{
			formData.append('location', inputsche.location);
			formData.append('location_name', inputsche.location_name);
			formData.append('gender', inputsche.gender);
			formData.append('birth_year', inputsche.birth_year);
		}
        const paymentIntentResponse = await API.post('create_payment_intent_for_product_web', formData);
 
        if (paymentIntentResponse.data.status === false) {
            setLoading(false);
            gettoastwarning(paymentIntentResponse.data.message, '');
            return;
        }
 
        const clientSecret = paymentIntentResponse.data.data.clientSecret;
 
        // Confirm the payment
        const result = await stripe.confirmCardPayment(clientSecret, {
            payment_method: {
                card: elements.getElement(CardNumberElement),
                billing_details: {
                    name: `${inputsche.name}`,
                    email: inputsche.email,
                },
            },
        });
        if (result.error) {
            PaymentIntentFail(paymentIntentResponse.data.data.paymentIntentId, result.error.message);
            setLoading(false);
            gettoastwarning(result.error.message, '');
        } else {
            pay(paymentIntentResponse.data.data.paymentIntentId);
        }
    } catch (error) {
			setLoading(false);
			var msg='Payment Intent: '+error.message;
        gettoastwarning(msg, '');
    } finally {
        //setLoading(false);
    }
 }
function PaymentIntentFail(intent_id,message){
	let formData = new FormData(); 
	formData.append('payment_intent_id', intent_id);
	API.post('product_payment_intent_cancel', formData)
		.then(response1 => {
		if(response1.data.status === false){
			
		}else{
		   
		}                  
	}).catch(error => {
		
	}); 
}
function pay(intent_id){
		var is_ireland=0;
    		if(parseInt(inputsche.country_id)===105)
    			{
    				is_ireland=0;
    			}else if(parseInt(inputsche.country_id)===232)
    			{
    				is_ireland=2;
    			}else{
    				is_ireland=1;
    			}

		let formData = new FormData(); 
		formData.append('email', inputsche.email);
        formData.append('first_name', inputsche.first_name);
        formData.append('last_name', inputsche.last_name);
        formData.append('country_code', inputsche.country_code);
        formData.append('mobile_number', inputsche.mobile_number);
        formData.append('country_id', inputsche.country_id);
        formData.append('county', inputsche.county);
        formData.append('address', inputsche.address);
        formData.append('postcode', inputsche.postcode);
        formData.append('product_amount', inputs.price);
        formData.append('product_vat', inputs.vat_total);
        formData.append('product_vat_per', inputs.vat);
        formData.append('is_ireland', is_ireland);
        formData.append('shipping_within_ireland', inputs.shipping_within_ireland);
        formData.append('international_shipping', inputs.international_shipping);
        formData.append('grand_total', inputs.grand_total);
        formData.append('product_id', inputs.id); 
        formData.append('qty', qty);
		formData.append('payment_intent_id', intent_id);
		formData.append('is_newsletter', inputsche.single_event ? 1 : 0);
        if(inputsche.single_event)
		{
			formData.append('location', inputsche.location);
			formData.append('location_name', inputsche.location_name);
			formData.append('gender', inputsche.gender);
			formData.append('birth_year', inputsche.birth_year);
		}
		API.post('product_order_book', formData)
			.then(response1 => {
				
			if(response1.data.status === false){
				setLoading(false);
				gettoastwarning(response1.data.message,'');
			}else{
			   var order_number=response1.data.data.order_number;
			   navigate('/thank-you',{ state: { order_number:order_number } });
			}                  
		}).catch(error => {
			 setLoading(false);
			 var msg='Payment: '+error.message;
			 gettoastwarning(msg,'');
		}); 
  }



  return (
    <Form onSubmit={handleSubmit}>
		<div className="row g-3 mb-3">
		  <div className="col-md-12">
		 
			<Form.Group controlId="cardNumber">
			  <Form.Label>Card number</Form.Label>
			  <div className="form-control">
			  <CardNumberElement options={{
				disableLink: true,
				style: {
				  base: {
					lineHeight: '24px', // this affects the height
					'::placeholder': {
					  color: '#6c757d',
					},
				  },
				  invalid: {
					color: '#dc3545',
				  },
				},
			  }} />
			  </div>
			</Form.Group>
		  </div>
		</div>
		<div className="row g-3 mb-3">
		  <div className="col-md-6">
			<Form.Group controlId="expiryDate">
			  <Form.Label>Expiration date</Form.Label>
			  <div className="form-control">
			  <CardExpiryElement options={{
				style: {
				  base: {
					lineHeight: '24px', // this affects the height
					'::placeholder': {
					  color: '#6c757d',
					},
				  },
				  invalid: {
					color: '#dc3545',
				  },
				},
			  }} />
			  </div>
			</Form.Group>
		  </div>
		  <div className="col-md-6">
			<Form.Group controlId="cvv">
			  <Form.Label>CVC/CVV</Form.Label>
			  <div className="form-control ">
			  <CardCvcElement  options={{
				style: {
				  base: {
					lineHeight: '24px', // this affects the height
					'::placeholder': {
					  color: '#6c757d',
					},
				  },
				  invalid: {
					color: '#dc3545',
				  },
				},
  }} />
			  </div>
			</Form.Group>
		  </div>
		</div>
		
		<Button type="submit" className="mt-4 w-100 ne">CONFIRM - {inputs.symbol}{Number(inputs.grand_total).toFixed(2)}</Button>
		{loading && (
	   <div className="loadingClass">
			<img src={loader} alt="loader"/>
		</div>
	   )}
	  </Form>
  );
};

export default CheckoutForm;
